import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

/**
 * MetadataToggle - Floating Action Button for toggling metadata visibility
 *
 * Part of Phase 10: Metadata System
 * Shows/hides "last updated" timestamps throughout the profile
 */

interface MetadataToggleProps {
  show: boolean;
  onChange: (show: boolean) => void;
}

export const MetadataToggle: React.FC<MetadataToggleProps> = ({ show, onChange }) => {
  return (
    <Tooltip title={show ? 'Hide Last Updated' : 'Show Last Updated'} placement="left">
      <Fab
        color={show ? 'primary' : 'default'}
        onClick={() => onChange(!show)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000
        }}
        aria-label={show ? 'Hide metadata' : 'Show metadata'}
      >
        {show ? <VisibilityOff /> : <Visibility />}
      </Fab>
    </Tooltip>
  );
};